/**
 * Whether the /login page should offer username + password alongside SSO.
 *
 * This exists as a local-development escape hatch for when SSO is not usable,
 * not as a supported way in. It is gated twice on purpose: the env flag turns
 * it on, and the dev-build check means a production bundle cannot expose it
 * even if VITE_ENABLE_PASSWORD_LOGIN reaches a build environment by accident.
 */
export const passwordLoginEnabled = (params: {
  envFlag: string | undefined;
  isDev: boolean;
}): boolean => {
  const { envFlag, isDev } = params;
  return envFlag === 'true' && isDev;
};

export default passwordLoginEnabled;
